import { sortCollectionItems } from "../../../shared/lib/sort/sortCollectionItems.js";
const sortEquipmentGroupsMap = (equipmentGroupsMap) => {
  const equipmentGroups = Object.values(equipmentGroupsMap).reduce((acc, group) => {
    if (!group.items.length) {
      return acc;
    }
    group.items.sort((itemsA, itemsB) => {
      const aItem = itemsA.find((item) => item);
      const bItem = itemsB.find((item) => item);
      return sortCollectionItems(aItem || {}, bItem || {});
    });
    return [...acc, group];
  }, []).sort((a, b) => sortCollectionItems(a, b));
  return equipmentGroups;
};
export {
  sortEquipmentGroupsMap
};
